/**
 * @author Ka Wing Chin <kawing.chin@takeaway.com>
 * @class Takeaway.PaymentMethod
 */

import Utils from '../lib/utils'

export default class PaymentMethod {
  constructor (obj) {
    if (obj !== undefined) {
      for (var prop in obj) {
        this[prop] = obj[prop]
      }
    }
  }

  // This sucks
  static ID = Object.freeze({
    Cash: '0',
    Voucher: '13'
  })

  /**
   * @property {String} id
   * e.g.
   * iDEAL 3
   * Visa 6_1
   * Mastercard 6_2
   */
  id
  /**
   * @property {String} id
   * Only for payment methods that contain sub ids
   * e.g. Creditcard has Visa, Mastercard and American Express. Main id would be 6 then.
   */
  mainId
  /**
   * @property {String} id
   * Only for payment methods that contain sub ids
   * e.g. Creditcard has Visa (1), Mastercard (2) and American Express (3). Main id would be 6 then.
   */
  subId
  name
  transactionFixed
  transactionPercentage

  /**
   * Calculate transaction costs.
   * @param {float} price the price the transaction costs needs to be calculated on.
   * @return {float} transaction costs.
   */
  calculateTransactionCosts = function (price) {
    if (price === 0) {
      return 0
    }

    if (this.transactionFixed === undefined) {
      return 0
    }

    let costs = 0
    if (this.transactionFixed === 0) {
      if (this.transactionPercentage !== 0) {
        costs = (price * (this.transactionPercentage) / 100)
      }
    } else {
      costs = this.transactionFixed
    }

    if (costs !== 0) {
      costs = Utils.toMoney(parseFloat(costs), 2)
    }

    return costs
  }
}
